import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { rgba } from 'polished';

import { getLanguageCode } from '../utils';

import MainNavigation from './MainNavigation';
import LocaleSelector from './LocaleSelector';
import Hamburger from './Hamburger';
import Block from './Block';
import Container from './Container';
import ContainerHeader from './ContainerHeader';
import Logo from './Logo';

const OffCanvas = styled(Block)`
  position: fixed;
  background-color: ${({ theme }) => rgba(theme.colors.grayLight, 0.95)};
  transition: all 0.25s;
  transform: translate3d(0, ${({ isOpen }) => (isOpen ? '0' : '-100%')}, 0);
  overflow: auto;
  padding-bottom: ${({ theme }) => theme.spacing.baseUp4};

  width: 100%;
  left: 0;
  top: 0;
  height: 100%;
  z-index: -1;
  padding-top: 80px;

  ${breakpoint('tablet')`
    display: none;
  `};
`;

class SiteHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      offCanvasIsOpen: false,
    };
  }

  onToggleMenu = () => {
    this.setState(state => ({
      offCanvasIsOpen: !state.offCanvasIsOpen,
    }));
  };

  render() {
    const { selectedLocale, location, isSticky } = this.props;
    const { offCanvasIsOpen } = this.state;

    return (
      <>
        <Container>
          <ContainerHeader
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            px="baseUnit"
          >
            <Link
              to={
                selectedLocale === 'en-us'
                  ? '/'
                  : `/${getLanguageCode(selectedLocale)}`
              }
            >
              <Logo
                color={isSticky ? 'orange' : 'white'}
                height={{ mobile: '36px', tablet: '55px' }}
                width="auto"
                alt="QuizRR home"
              />
            </Link>

            <Block display="flex" alignItems="center">
              <Block display={{ mobile: 'none', tablet: 'flex' }}>
                <MainNavigation
                  selectedLocale={selectedLocale}
                  isSticky={isSticky}
                  location={location}
                  linkcolor={isSticky ? 'blueDark' : 'white'}
                  onNavigation={this.onToggleMenu}
                />
              </Block>

              <LocaleSelector
                selectedLocale={selectedLocale}
                location={location}
                optionColor={isSticky ? 'blueDark' : 'white'}
              />

              <Block display={{ mobile: 'block', tablet: 'none' }}>
                <Hamburger
                  onClick={this.onToggleMenu}
                  isSticky={isSticky}
                  isActive={offCanvasIsOpen}
                />
              </Block>
            </Block>
          </ContainerHeader>
        </Container>

        <OffCanvas isOpen={offCanvasIsOpen}>
          <MainNavigation
            selectedLocale={selectedLocale}
            isSticky={isSticky}
            location={location}
            linkcolor="blueDark"
            onNavigation={this.onToggleMenu}
          />
        </OffCanvas>
      </>
    );
  }
}

SiteHeader.propTypes = {
  selectedLocale: PropTypes.string.isRequired,
  location: PropTypes.shape({}).isRequired,
  isSticky: PropTypes.bool.isRequired,
};

export default SiteHeader;
